import React from 'react';
import { Box, Text, Flex, Button, Progress, HStack } from '@chakra-ui/react';
import { path } from "ramda";
import { useUpdateDecisionMutation } from "../app/api";
import { useSelector } from 'react-redux';

export const VoteCount = ({ items, items2, decision_id, order_nr, next_to_show, 
  show_until, done_item, data_input, next_btn_visible, is_last }) => {

  const [moveForward] = useUpdateDecisionMutation();
  const texts = useSelector(path(["ui", "ui_texts"]));

  // Group votes by input_id, count value_number === 1
  const voteCounts = items.filter(item => item.value_text).reduce((acc, item) => {
    acc[item.id] = { 
      text: item.value_text, 
      count: 0 
    };
    return acc;
  }, {});

  (items2 || []).forEach(row => {
    if (row.value_number === 1 && voteCounts[row.input_id]) {
      voteCounts[row.input_id].count += 1;
    }
  });

  const rankedList = Object.entries(voteCounts)
    .map(([id, { text, count }]) => ({ id, text, count }))
    .sort((a, b) => b.count - a.count);

  const maxVotes = Math.max(...rankedList.map(x => x.count), 1);

  const hide_next_btn = (done_item === null || data_input == null)
    ? (show_until > order_nr)
    : !next_btn_visible;

  return (
    <Box>
      {rankedList.map((option, n) => (
        <Box key={option.id} mb={2}>
          <HStack justify="space-between" mb={1}>
            <Text fontSize="sm" fontWeight={n === 0 ? "bold" : "normal"}>
              {option.text}
            </Text>
            <Text fontSize="sm" fontWeight="bold" minW="40px" textAlign="right">
              {option.count}
            </Text>
          </HStack>
          <Progress 
            value={(option.count / maxVotes) * 100} 
            size="sm" 
            colorScheme={n === 0 ? "teal" : "gray"} 
            borderRadius="md"
          />
        </Box>
      ))}
      {(is_last || hide_next_btn) ? null : (
        <Flex mt={3} gap={2}>
          <Button size="md" colorScheme="blue" onClick={() => {
            moveForward({
              id: decision_id,
              done: order_nr,
              show_until: next_to_show
            });
          }}>
            {texts.next}
          </Button>
        </Flex>
      )}
    </Box>
  );
};
